<template>
  <div>
    <v-btn
      class="w-full py-6 d-flex justify-start align-center border-radius"
      :color="!isFacebookConnected ? 'grey-lighten-9' : 'grey-lighten-4'"
      elevation="3"
      :disabled="!isFacebookConnected"
      @click="onClick"
    >
      <r-img
        :src="KindTypeIcon.instagramPost"
        width="30"
        height="30"
        class="mr-2 flex-grow-0"
      />
      {{ $t('buttons.social-media.connect-instagram') }}
    </v-btn>
    <v-alert
      v-if="!isFacebookConnected"
      type="info"
      density="compact"
      variant="tonal"
      class="mb-0 -mt-1 border-radius"
    >
      {{ $t('tooltips.social-media.connect-facebook-first') }}
    </v-alert>
  </div>
</template>

<script>
import { KindTypeIcon } from '../../enums/KindType'

export default {
  props: {
    connect: {
      type: Function,
      required: true,
    },
    isFacebookConnected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      KindTypeIcon,
    }
  },
  emits: ['featureEnabled'],
  methods: {
    async onClick() {
      const result = await this.connect()
      if (result === false) this.$emit('featureEnabled', false)
    },
  },
}
</script>
<style scoped>
.border-radius {
  border-radius: 4px !important;
}
</style>
